export default "__VITE_ASSET__2a062c4a__"